import paymentsBlockImg1 from "images/new/payments-block-img-1.png";
import paymentsBlockImg2 from "images/new/payments-block-img-2.png";
import React from "react";

interface TransactionCard {
  id: number;
  title: string;
  description: string;
}

const GlobalTransactionsSection: React.FC = () => {
  return (
    <section className="py-6 md:py-10">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-normal mb-4 max-w-xl mx-auto">Simplifying global transactions for your business</h2>
          <p className="text-gray-600 max-w-xl mx-auto">Multi-currency accounts and efficient cross-border payments. Start trading in 72 hours.</p>
        </div>

        <div className="space-y-8">
          {/* First Row */}
          <div className="grid md:grid-cols-3 gap-8">
            {/* Left Card - 1/3 width */}
            <div className="bg-white rounded-3xl p-8 shadow-sm">
              <h3 className="text-2xl font-semibold text-purple-900 mb-4">Fast, Seamless Payments</h3>
              <p className="text-gray-600">Fast, seamless international payments of suppliers and staff in 120 countries.</p>
            </div>

            {/* Right Card - 2/3 width */}
            <div className="md:col-span-2 flex bg-slate-900 rounded-3xl text-white overflow-hidden relative">
              <div className="p-8">
                <h3 className="text-2xl font-semibold mb-4">Fast and Secure</h3>
                <p className="text-gray-300 mb-6">Cross-border payments in 21 currencies.</p>
              </div>
              <div className="space-y-4 -mr-2 -mt-2 md:-mr-12 md:-mt-10">
                <img src={paymentsBlockImg1} alt="" />
              </div>
            </div>
          </div>

          {/* Second Row */}
          <div className="grid md:grid-cols-3 gap-8">
            {/* Left Card - 2/3 width */}
            <div className="md:col-span-2 flex bg-slate-800 rounded-3xl text-white">
              <div className="p-8">
                <h3 className="text-2xl font-semibold mb-4">21 currencies per UK account</h3>
                <p className="text-gray-300">21 currencies per UK account allows your customers to pay almost anywhere in the world.</p>
              </div>
              <div className="space-y-4">
                <img src={paymentsBlockImg2} alt="" />
              </div>
            </div>

            {/* Right Card - 1/3 width */}
            <div className="bg-white rounded-3xl p-8 shadow-sm">
              <h3 className="text-2xl font-semibold text-purple-900 mb-4">Worldwide Payments</h3>
              <p className="text-gray-600">Accept and process payments worldwide to unlock new markets and revenues quickly.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalTransactionsSection;
